/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { DateRange } from '@mui/lab/DateRangePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { MobileDateRangePicker } from '@mui/lab';
import Modal from '../../components/modals/modal';
import DateF from '../../models/date-f';

interface Props {
  modalOpen: boolean,
  homeRangeDates: string[],
  handleCloseModal: () => void;
  handleSetRange: (values: DateRange<Date>) => void;
}

export default function DateRangePicker({ ...props }: Props) {
  const [values, setValues] = useState<DateRange<Date>>([null, null]);
  const [error, setError] = useState('');
  const validDateRange = props.homeRangeDates.some((date) => {
    if (date.length) {
      return new DateF(date).isDate();
    }
    return true;
  });

  useEffect(() => {
    if (!validDateRange) {
      setError('One or more of your dates are invalid');
      return;
    }

    let datesFormatted: DateRange<Date> = [null, null];

    if (props.homeRangeDates.length) {
      // @ts-ignore
      datesFormatted = props.homeRangeDates.map((date) => new Date(date));
    }

    setValues(datesFormatted);
  }, []);

  const handleChange = (range: DateRange<Date>) => {
    if (error) {
      setError('');
    }

    setValues(range);
  };

  const handleSubmit = () => {
    props.handleSetRange(values);
    setValues([null, null]);
  };

  const handleClosePicker = () => {
    setValues([null, null]);
    props.handleCloseModal();
  };

  return (
    <Modal
      title="Custom Date Range"
      positive="Submit"
      positiveDisabled={!!error.length}
      negative="Cancel"
      onPositive={handleSubmit}
      onNegative={handleClosePicker}
      onClose={handleClosePicker}
      maxWidth="xs"
      open={props.modalOpen}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <MobileDateRangePicker
          disableCloseOnSelect
          startText="Start date"
          endText="End date"
          minDate={new Date('1900-01-01')}
          value={values}
          onAccept={() => setError('')}
          onChange={handleChange}
          onError={() => setError('Invalid date range')}
          renderInput={(startProps, endProps) => (
            <Box sx={{
              display: 'flex',
              justifyContent: 'space-around',
              alignItems: 'center',
            }}
            >
              <TextField {...startProps} />
              <Box sx={{ mx: 2 }}> to </Box>
              <TextField {...endProps} />
            </Box>
          )}
        />
      </LocalizationProvider>
    </Modal>
  );
}
